import { render, staticRenderFns } from "./ListMascaraTransportadorSacPublicoView.vue?vue&type=template&id=c4452cbe&"
import script from "./ListMascaraTransportadorSacPublicoView.vue?vue&type=script&lang=ts&"
export * from "./ListMascaraTransportadorSacPublicoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports